export default __webpack_public_path__ + "static/media/02-icon-zusammenarbeit.af57b347.svg";